import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ParametrizacionMinutosGraciaService} from "../../services/parametrizacion-minutos-gracia.service";

@Component({
  selector: 'app-parametrizacion-minutos-gracia',
  templateUrl: './parametrizacion-minutos-gracia.component.html',
  styleUrls: ['./parametrizacion-minutos-gracia.component.css']
})
export class ParametrizacionMinutosGraciaComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionMinutosGraciaService: ParametrizacionMinutosGraciaService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionMinutosGracia;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      minutosDeGracia: ['', [Validators.required, Validators.min(1), Validators.max(99)]],
    });
    this.girdComponent();
    this.getAllMinutos();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllMinutos() {
    this.loading = true;
    this._parametrizacionMinutosGraciaService.getAll().subscribe((res: any) => {
      const resList = new Array(res);
      this.rowData = resList;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'MINUTOS DE GRACIA',
        field: 'minutosDeGracia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarMinutosGracia.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarMinutosGracia({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.formulario.setValue(rowData);
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarMinutosGracia();
      } else {
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarMinutosGracia() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionMinutosGraciaService.actualizarMinutosGracia(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllMinutos();
      this.regresar();
    });
  }


  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }
}
